// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { screen } from "@rugby/XDL/Helpers";
import { xBaseTheme } from "@rugby/XDL/types";
import { css } from "styled-components";

export default {
    css: css`
      html {
        height: auto;
      }

      // to override background color (GlobalStyle in mobius)
      // body {
      //       background: ${getProp("theme.colors.common.white")};
      // }

      body {

        // XNG-Changes RUG-778: To fix header cutoff on mobile
        #react-app {
          ${screen("lte", "sm")`
            overflow-y: auto;
          `};
        }

        // To hide the live chat on print globally
        @media print {
          .tagove-livechat-widget, .breadcrumb-page {
            display: none;
          }
        }

        // XNG-Changes RUG-1047: Hide product name from Breadcrumbs in PDP
        div[data-test-selector="page_ProductDetailsPage"] {
          nav[data-test-selector="pageBreadcrumbs"] > :nth-last-child(-n+2) {
            display: none;
          }
        }

        // XNG-Changes RUG-1116: On search auto complete, search overlay should not cover search input 
        label[id^="headerSearch"] + div > div.tippyVisibility_overlay {
          top: 147px;
        }
      }
    `,
} as xBaseTheme["globalStyle"];
